<template>
  <div class="animated fadeIn">
    <b-card>
      <vue-loading :active.sync="nonWorkingDaysTableProps.isLoading" :is-full-page="false"/>
      <vue-loading :active.sync="isLoadingDeleting" :is-full-page="false"/>
      <div slot="header">
        <b>Prosti dnevi</b>
        <div class="card-header-actions">
          <CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_nonWorkingDaysTableRefresh">
            <CIcon name="cil-loop-circular"/>
          </CLink>
          <CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_nonWorkingDaysTableResetFilters">
            <CIcon name="cil-x"/>
          </CLink>
          <CLink title="Dodaj prosti dnevi" href="#" class="card-header-action btn-setting" @click.stop="click_nonWorkingDayCreate">
            <CIcon name="cil-plus"/>
          </CLink>
        </div>
      </div>

      <div class="table-filters-wrap">
        <div class="single-filter-wrap">
          <label for="search-filter">Iskanje</label>
          <b-form-input
              v-model="nonWorkingDaysTableProps.inputFilter.search"
              type="text"
              id="search-filter"
              @input="nonWorkingDaysTableTextFilter_change"/>
        </div>
        <div class="single-filter-wrap">
          <label for="year-filter">Leto</label>
          <b-form-select
              v-model="nonWorkingDaysTableProps.inputFilter.year"
              :options="years"
              id="year-filter"
              @input="nonWorkingDaysTableTextFilter_change"></b-form-select>
        </div>
      </div>

      <b-table
          ref="nonWorkingDaysTable"
          responsive="sm"
          striped
          show-empty
          hover
          :empty-text="nonWorkingDaysTableProps.empty_text"
          :empty-filtered-text="nonWorkingDaysTableProps.empty_filtered_text"
          :fields="nonWorkingDaysTableProps.fields"
          :current-page="nonWorkingDaysTableProps.currentPage"
          :per-page="nonWorkingDaysTableProps.itemsPerPage"
          :items="nonWorkingDaysTable_items">
        <template v-slot:cell(date)="data">
          {{ data.item.date | viewDate }}
        </template>
        <template v-slot:cell(actions)="data">
          <div>
            <b-button title="Edit non-working day" variant="primary" @click.stop="click_nonWorkingDayEdit(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-pencil"/>
            </b-button>
            <b-button title="Delete non-working day" variant="danger" @click.stop="click_nonWorkingDayDelete(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-trash"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <nav>
        <b-row>
          <b-col>
            <b-pagination :total-rows="nonWorkingDaysTableProps.totalItems" :per-page="nonWorkingDaysTableProps.itemsPerPage" v-model="nonWorkingDaysTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
          </b-col>
          <b-col cols=2>
            <a class="page-link rows_total float-right">Št. vrstic: {{ nonWorkingDaysTableProps.totalItems }}</a>
          </b-col>
          <b-col cols=1>
            <b-form-select v-model="nonWorkingDaysTableProps.itemsPerPage" :options="nonWorkingDaysTableProps.options_numRowsOnPage"></b-form-select>
          </b-col>
        </b-row>
      </nav>
    </b-card>
    <non-working-day-create-edit-modal ref="nonWorkingDayCreateEditModal" @emit_nonWorkingDayCreatedOrEdited="emit_nonWorkingDayCreatedOrEdited"/>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import settings from '@/settings.js';
import { NON_WORKING_DAYS_LIST, NON_WORKING_DAY_DELETE } from "@/store/actions/nonWorkingDays";
import NonWorkingDayCreateEdit from "@/views/modals/NonWorkingDayCreateEdit.vue";

export default {
  name: 'NonWorkingDays',
  components: {
    'non-working-day-create-edit-modal': NonWorkingDayCreateEdit
  },
  data () {
    return {
      nonWorkingDaysTableProps: {
        fields: [
          { key: 'id', label: 'Id', sortable: true, class: 'tdNonWorkingDaysId' },
          { key: 'name', label: 'Naziv', sortable: true, class: '' },
          { key: 'date', label: 'Data', sortable: true, class: '' },
          { key: 'actions', label: '#', sortable: false, class: 'tdNonWorkingDaysActions' },
        ],
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
        isLoading: false,
        options_numRowsOnPage: [
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 200, text: '200' },
          { value: 1000, text: '1000' }
        ],
        empty_text: '',
        empty_filtered_text: 'Ni zadetkov',
        inputFilter: {
          search: null,
          year: new Date().getFullYear()
        },
        textFilterTimeout: null,
        errorText: ''
      },
      isLoadingDeleting: false,
    }
  },
  watch: {
  },
  computed: {
    years: function () {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 9;
      const yearsObject = {};

      for (let year = startYear; year <= currentYear; year++) {
        yearsObject[year.toString()] = year;
      }

      return yearsObject;
    }
  },
  methods: {
    click_nonWorkingDayCreate: function () {
      let modalInput = {
        mode: 1, // create
        modalNonWorkingDay: null
      }
      this.$refs.nonWorkingDayCreateEditModal.showModal(modalInput);
    },
    click_nonWorkingDayEdit: function (data) {
      let modalInput = {
        mode: 2, // edit
        modalNonWorkingDay: data
      }
      this.$refs.nonWorkingDayCreateEditModal.showModal(modalInput);
    },
    click_nonWorkingDayDelete: function (data) {
      this.$bvModal.msgBoxConfirm('Želite izbrisati dan ' + data.name + ' (#' + data.id + ')?', {
        title: 'Potrdite izbris dneva',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DA',
        cancelTitle: 'NE',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value === true) {
          this.isLoadingDeleting = true;
          this.$store.dispatch(NON_WORKING_DAY_DELETE, { id: data.id })
              .then((responseData) => {
                this.isLoadingDeleting = false;
                this.$refs.toastr.s('Dan ' + data.name + '(#' + data.id + ') uspešno izbrisan.');
                this.$refs.nonWorkingDaysTable.refresh();
              })
              .catch(error => {
                this.isLoadingDeleting = false;
                console.error(error);
                if(error.response && error.response.data && error.response.data.code) {
                  this.$refs.toastr.e('Napaka pri brisanju! (' + error.response.data.code + ')');
                } else {
                  this.$refs.toastr.e('Napaka pri brisanju! Prosimo poizkusite kasneje.');
                }
              });
        }
      }).catch(err => {
        console.error(err);
      })
    },
    click_nonWorkingDaysTableRefresh: function () {
      this.$refs.nonWorkingDaysTable.refresh();
    },
    click_nonWorkingDaysTableResetFilters: function () {
      this.nonWorkingDaysTableProps.inputFilter.search = null;
      this.nonWorkingDaysTableProps.inputFilter.year = new Date().getFullYear();
      this.$refs.nonWorkingDaysTable.refresh();
    },
    emit_nonWorkingDayCreatedOrEdited: function (data) {
      if (data.message === 'created') {
        this.$refs.toastr.s('Dan ' + data.nonWorkingDay.name + ' uspešno dodan.');
      } else if (data.message === 'edited') {
        this.$refs.toastr.s('Dan ' + data.nonWorkingDay.name + ' uspešno urejen.');
      } else {
        this.$refs.toastr.e('Neznan odziv strežnika.');
      }
      this.$refs.nonWorkingDaysTable.refresh();
    },
    nonWorkingDaysTable_items: function (ctx) {
      this.nonWorkingDaysTableProps.isLoading = true;
      return this.$store.dispatch(NON_WORKING_DAYS_LIST, { ctx: ctx, tableProps: this.nonWorkingDaysTableProps })
          .then((responseData) => {
            this.nonWorkingDaysTableProps.isLoading = false;
            this.nonWorkingDaysTableProps.items = responseData.nonWorkingDays.data;
            this.nonWorkingDaysTableProps.totalItems = responseData.nonWorkingDays.total;
            this.nonWorkingDaysTableProps.empty_text = 'Ni vnosov';
            return responseData.nonWorkingDays.data;
          })
          .catch(error => {
            this.nonWorkingDaysTableProps.isLoading = false;
            this.nonWorkingDaysTableProps.items = [];
            this.nonWorkingDaysTableProps.totalItems = 0;
            this.nonWorkingDaysTableProps.empty_text = 'Napaka pri pridobivanju podatkov zaradi nedelovnih dni';
            console.log(error);
            return [];
          });
    },
    nonWorkingDaysTableTextFilter_change: function (value) {
      if (this.nonWorkingDaysTableProps.textFilterTimeout !== null) {
        clearTimeout(this.nonWorkingDaysTableProps.textFilterTimeout);
      }
      this.nonWorkingDaysTableProps.textFilterTimeout = setTimeout(() => {
        this.$refs.nonWorkingDaysTable.refresh();
      }, settings.filterTimeoutLength);
    },
  },
  created: function () {
  }
}
</script>
<style scoped>
.table-responsive-sm {
  margin-bottom: 0;
}
.pagination {
  margin-left: 1rem;
  margin-right: 1rem;
}
.page-link.rows_total {
  text-align: center;
  border-radius: 5px;
  width: 120px;
}
.table-filters-wrap {
  margin-bottom: 15px;
  float: left;
}
.single-filter-wrap {
  width: 200px;
  float: left;
  margin-right: 15px;
}
</style>

<style>
.tdNonWorkingDaysId {
  width: 120px;
}
.tdNonWorkingDaysActions {
  width: 120px;
}
</style>